var socialmediashare = (function () {

    var replaceDynamicText = function (text) {
        var re = new RegExp("{([^}{]+)}", "g");
        while ((result = re.exec(text)) !== null) {
            var match = result[0];
            var elemName = result[1];
            var replaceText = "";
            if ($("input[name='" + elemName + "']").length > 0) {
                replaceText = $("input[name='" + elemName + "']").val();
            }
            text = text.replace(match, replaceText);
        }
        return text;
    };

    $(".facebook_icon").click(function (e) {
        e.preventDefault();
        var $this = $(this);
        var link= $this.data("link");
        var picture = $this.data("picture"); 
        var name = replaceDynamicText($this.data("name"));
        var caption = replaceDynamicText($this.data("caption"));
        var description = replaceDynamicText($this.data("description"));

        FB.ui(
            {
                method: 'feed',
                name: name,
                link: link,
                picture: picture,
                caption: caption,
                description: description
            },
            function (response) {

            }
        );
    });

    $(".twitter_icon").click(function () {
        var $this = $(this);
        var url = $this.data("url");
        var text = replaceDynamicText($this.data("text"));

        var twitterurl = "https://twitter.com/share" + "?url=" + encodeURIComponent(url) + "&text=" + encodeURIComponent(text);

        if ($(window).width() < 768) {
            $this.attr("target", "_blank").attr("href", twitterurl);
        }
        else {
            var width = 575,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts = 'status=1,menubar=no,titlebar=no,toolbar=no' +
                    ',width=' + width +
                    ',height=' + height +
                    ',top=' + top +
                    ',left=' + left;
            window.open(twitterurl, 'twitter', opts);
            return false;
        }
    });

})();